<div class="tnb">
  <redispatch-westnetz-page>
    <div class="page-area">
      <redispatch-navigation-header></redispatch-navigation-header>
      <router-outlet class="main-area"></router-outlet>
    </div>
    <redispatch-westnetz-footer></redispatch-westnetz-footer>
  </redispatch-westnetz-page>
</div>
